import { z } from "zod";

export const PartnerNetworkFilterFormSchema = z.object({
  searchTerm: z.string().optional(),
  isFavoriteOnly: z.boolean().optional().default(false),
  isFeaturedOnly: z.boolean().optional().default(false),
  trades: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
      }),
    )
    .optional()
    .default([]),
  businessRoles: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
        description: z.string().nullable(),
      }),
    )
    .optional()
    .default([]),
  departments: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
      }),
    )
    .optional()
    .default([]),
});

export type PartnerNetworkFilterFormData = z.infer<
  typeof PartnerNetworkFilterFormSchema
>;
